import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { message } from '../../../translate';

const propTypes = {
  optionView : PropTypes.string.isRequired
}

const renderPrincipal = ( optionView ) => {

  if ( optionView === '1' ) { // Mostrar Vista
    return (
      <Link to="/applications_softaculous" style={{ textDecoration : 'none', color: '#748497' }}> { message('_back') } </Link>
    )
  } else if ( optionView === '0' ) { // null
    return null;
  }
}

const changeLocale = (evt) => {
  evt.preventDefault();
  let opt = evt.target.getAttribute('data-opt');
  localStorage.locale = opt;
  window.location.reload();
}

const Header = ({ optionView }) => {
  return (
    <div className="container">
      <header className="blog-header py-3">
        <div className="row flex-nowrap justify-content-between align-items-center">

          <div className="col-4 pt-1">
            { renderPrincipal( optionView ) }
          </div>

          <div className="col-4 text-center">
            <a className="blog-header-logo text-dark" href="https://www.hostingsoluciones.biz"> Hosting Soluciones </a>
          </div>

          <div className="col-4 d-flex justify-content-end align-items-center">
            <div className="form-inline my-2 my-lg-0">
              <ul className="navbar-nav mr-auto">
                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" id="dropdown01" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{ message('language') }</a>
                  <div className="dropdown-menu" aria-labelledby="dropdown01">
                    <a className="dropdown-item" data-opt = "es"    onClick = { changeLocale } >{ message('spanish') }</a>
                    <a className="dropdown-item" data-opt = "en-US" onClick = { changeLocale } >{ message('english') }</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </header>
    </div>
  )
}

Header.propTypes = propTypes;

export default Header;



// WEBPACK FOOTER //
// ./src/components/Global/Header/index.js